import React from 'react';
import { Form as AntForm } from 'antd';
import type { FormProps } from 'antd';
import clsx from 'clsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Form = <Values = any,>({
  className,
  ...props
}: FormProps<Values>) => {
  // NOTE: antd's Form narrows `children` to ReactNode while FormProps (via
  // rc-field-form) also allows a render prop, so forward the caller's shape.
  const forwarded = props as Omit<FormProps<Values>, 'children'> & {
    children?: React.ReactNode;
  };

  return (
    <AntForm<Values> {...forwarded} className={clsx('wk-form', className)} />
  );
};

Form.Item = AntForm.Item;
Form.List = AntForm.List;
Form.useForm = AntForm.useForm;
Form.useFormInstance = AntForm.useFormInstance;
Form.useWatch = AntForm.useWatch;
Form.Provider = AntForm.Provider;
Form.ErrorList = AntForm.ErrorList;
